"use client";

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      id: 'faq_launch',
      question: 'When will MeetX launch?',
      answer: 'We\'re planning a Q2 2026 launch for iOS and Android. Join our waitlist to get notified when we go live and receive early access.',
    },
    {
      id: 'faq_cost',
      question: 'How much does MeetX cost?',
      answer: 'Pricing details will be announced closer to launch. We\'re committed to offering fair pricing with premium features available at every tier. Waitlist members will receive special launch pricing.',
    },
    {
      id: 'faq_platforms',
      question: 'What platforms will MeetX be available on?',
      answer: 'MeetX will launch simultaneously on iOS (iPhone) and Android. A web version is planned for later in 2026.',
    },
    {
      id: 'faq_verification',
      question: 'How does profile verification work?',
      answer: 'All users must verify their identity through government-issued ID and a real-time selfie. Our AI facial recognition confirms the photo matches the ID. This process takes less than 2 minutes.',
    },
    {
      id: 'faq_algorithm',
      question: 'What makes your AI different from other apps?',
      answer: 'Our AI analyzes 50+ compatibility factors including values, lifestyle, communication style, and relationship goals - not just superficial traits. It learns from your feedback and continuously improves match quality.',
    },
    {
      id: 'faq_privacy',
      question: 'How do you protect my data?',
      answer: 'We use end-to-end encryption for all messages and video calls. Your data is never sold to third parties. You control who sees your profile and can delete your account (and all data) anytime.',
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-24 px-6 bg-muted/10 border-y border-white/5">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-6">
            Frequently Asked <span className="text-primary">Questions</span>
          </h2>
          <p className="text-lg text-muted-foreground font-light">
            Can&apos;t find what you&apos;re looking for? Use the contact form above.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={faq.id}
              className="glass-card rounded-2xl overflow-hidden transition-all"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-white/5 transition-colors"
              >
                <span className="text-lg font-semibold text-foreground pr-4">
                  {faq.question}
                </span>
                <Icon
                  name="ChevronDownIcon"
                  size={24}
                  className={`text-primary transition-transform flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              <div
                className={`px-6 overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <p className="text-muted-foreground leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}